import { useEffect } from "react";

const SITE = "https://www.brackenfelljuniorrugby.co.za";

export const SEO = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    const upsert = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = create(); document.head.appendChild(el); }
      return el;
    };
    if (description) {
      const tag = upsert('meta[name="description"]', () => { const m = document.createElement("meta"); m.name = "description"; return m; });
      tag.content = description;
      const og = upsert('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; });
      og.content = description;
    }
    if (title) {
      const ogt = upsert('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; });
      ogt.content = title;
    }
    const canonical = upsert('link[rel="canonical"]', () => { const l = document.createElement("link"); l.rel = "canonical"; return l; });
    canonical.href = SITE + window.location.pathname;
  }, [title, description]);
  return null;
};
